<template>
	<div class="template related-approval">
		<div class="panel_wrap upfile-file-part">
			<div class="file-wrap-title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="panel_content">
				<div class="upfile-list"></div>
				<div class="upload-file related-approval-btn">
					<!-- <input type="file" class="upload-button" /> -->
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:["dataVal"]
	}
</script>

<style>
	@import url("../../assets/css/common.css");
	
	.related-approval-btn{
		background-position: -396px -221px;
	}
</style>
